<template>
  <div>
    <a-modal
      v-model="visible"
      :loading="loading"
      title="Create Bundled Transaction"
      :width="this.settings['isMobileView'] ? 480 : 720"
      onOk="handleOk"
    >

      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Submit</a-button>
      </template>

      <div class="row">
        <div class="col-6">
          <p class="text-uppercase font-weight-bold lead">
            {{ oldrecord.name }}
          </p>
        </div>
        <div class="col-6">
          <p class="text-right">
            Bundled Code:
            <span class="lead font-weight-bold">{{ oldrecord.code }}</span>
          </p>
        </div>
      </div>

      <a-form :form="form">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Balance Qty</th>
              <th>Issue Qty</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product, index) in bundledProductProducts" :key="index">
              <td>
                <a-form-item>
                  <a-input-number
                    v-decorator="['product_name',{initialValue: product.product_name}]"
                    style="width: 25vw"
                    :disabled="true"
                    class="text-dark"
                  />
                </a-form-item>
              </td>
              <td>
              <a-form-item>
                  <a-input
                    v-decorator="[`product_quantity[${product.product_id}]`,{initialValue: product.quantity}]"
                    style="width: 100%"
                    :disabled="true"
                    class="text-dark"
                  />
                </a-form-item>
              </td>
              <td>
                <a-form-item>
                  <a-input
                    v-decorator="[`product_stock_quantity[${product.product_id}]`,{initialValue: product.quantity, rules: [{ required: true, message: 'Please input issue quantity!' }]}]"
                    style="width: 100%"
                    :disabled="false"
                    class="text-dark"
                  />
                </a-form-item>
              </td>
              <td class="align-middle text-center">
                <a href="javascript:;"
                  class="text-danger"
                  @click.prevent="handleRemoveProductGrouping(index)"
                >
                  <i class="fe fe-trash-2"/>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr>

        <div class="row mb-0">
          <div class="col-md-6">
            <a-form-item label="Bundled Quantity">
              <a-input-number
                :min="1"
                v-decorator="['bundled_product_quantity',{initialValue: '1'}, {rules: [{ required: true, message: 'Please input quantity!'}]}]"
                style="width: 100%"
                @change="handleBundleProductQuantityChange"
              />
            </a-form-item>
          </div>

          <div class="col-md- 6">
            <a-form-item label="Date">
              <a-date-picker
                v-decorator="['transactionDate', {rules: [{ required: false, message: 'Please input date' }], initialValue: moment()},]"
                style="width: 100%"
                :format=dateFormat
              />
              </a-form-item>
          </div>
        </div>

        <div class="row align-items-center mb-0">
          <div class="col-md-12 col-12">
            <a-form-item label="Issued To (Student)">
              <a-select
                mode="multiple"
                show-search
                size="default"
                v-model="selectedIssuedToStudent"
                placeholder="Search student.."
                optionFilterProp="children"
                style="width: 100%"
                @change="handleChangeIssuedToStudent"
                @search="searchStudents"
                :filterOption="true"
                :defaultValue="undefined"
              >
                <a-select-option :value="0">
                  All Students
                </a-select-option>
                <template v-for="student in students">
                  <a-select-option :value="student.id" :key="student.id">
                    {{student.first_name + ' ' + student.last_name + ' | ' + student.student_code }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <!-- Select Staff -->
        <div class="row align-items-center mb-0">
          <div class="col-md-6 col-12">
              <a-form-item label="Issued By (Staff)">
                <a-select
                  show-search
                  size="default"
                  v-model="selectedIssuedBy"
                  placeholder="Search staff.."
                  optionFilterProp="children"
                  style="width: 100%"
                  @change="handleChangeIssuedBy"
                  @search="searchStaffs"
                  :filterOption="true"
                  :defaultValue="undefined"
                >
                  <a-select-option :value="0">
                    All Staffs
                  </a-select-option>
                  <template v-for="staff in staffs">
                    <a-select-option :value="staff.id" :key="staff.id">
                      {{staff.first_name + ' ' + staff.last_name}}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
          </div>
          <div class="col-md-6 col-12">
            <a-form-item label="Issued To (Staff)">
              <a-select
                show-search
                size="default"
                v-model="selectedTakenBy"
                placeholder="Search Staff.."
                optionFilterProp="children"
                style="width: 100%"
                @change="handleChangeTakenBy"
                @search="searchStaffs"
                :filterOption="true"
                :defaultValue="undefined"
              >
                <a-select-option :value="0">
                  Select Staffs
                </a-select-option>
                <template v-for="staff in staffs">
                  <a-select-option :value="staff.id" :key="staff.id">
                    {{staff.first_name + ' ' + staff.last_name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <a-form-item label="Remark">
              <a-input
                v-decorator="['remark']"
              />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'OutwardTransaction',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      selectedIssuedBy: null,
      selectedTakenBy: null,
      selectedIssuedToStudent: null,
      staffSearch: null,
      studentSearch: null,
      students: [],
      staffs: [],
      staffsMeta: {},
      staffCurrent: 1,
      staffPageSize: 10,
      staffSpinning: false,
      items: [],
      dateFormat: 'DD-MM-YYYY',
    }
  },
  mounted: function () {
    this.$eventBus.$on('showOutwardTransactionForm', this.showForm)
    // To Amar: Explain the use of the below:
    // this.name = this.item.product.name
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  props: ['bundledProductProducts'],
  methods: {
    moment,
    showForm: function(record) {
      this.visible = true
      this.oldrecord = record
      this.getStaffs()
      // To Amar: Explain the use of the below:
      /* setTimeout(() => {
        this.form.setFieldsValue({
          'name': record.products.name,
          'code': record.code,
          'balanceQuantity': record.product_stock === null ? 0 : record.product_stock.quantity,
        })
      }, 50) */
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleRemoveProductGrouping(index) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Click Ok to remove this product.`,
        onOk: () => {
          this.bundledProductProducts = this.bundledProductProducts.filter(
            (product, i) => i !== index
          )
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
    handleSubmit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        console.log('Values Data', values)
        console.log('err', err)
        const data = {
          bundled_product_id: this.oldrecord.id,
          products: this.bundledProductProducts,
          bundled_quantity: values.bundled_product_quantity,
          date: moment(values.transactionDate).format('YYYY-MM-DD HH:MM:ss'),
          students: this.selectedIssuedToStudent,
        }
        data.products.forEach(product => {
          product.product_stock_quantity *= data.bundled_quantity
        })
        if (!err) {
          this.$http
            .post(`/api/inventory/bundled_transaction/outward`, data)
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onOutwardTransaction')
                this.$notification['success']({
                  message: 'Bundled transaction created successfully',
                  description: 'Bundled Transaction created successfully',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
              this.selectedIssuedBy = null
              this.selectedTakenBy = null
              this.selectedIssuedToStudent = null
              this.oldrecord = {}
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
    getStaffs: function(isSearch) {
      this.staffSpinning = true

      let page = this.staffCurrent
      if (isSearch) {
        page = 1
        this.staffCurrent = 1
      }
      this.$http.get('/api/staff', {
        params: {
          limit: this.staffPageSize,
          search: this.staffSearch,
          page: page,
        },
      }).then(({ data }) => {
        this.staffs = data.data
        this.staffSpinning = false
        this.staffsMeta = data.meta
      })
    },
    searchStaffs: function(value) {
      if (value) {
        this.staffSearch = value
        this.getStaffs(true)
      }
    },
    getStudents: function(isSearch) {
      this.staffSpinning = true

      let page = this.staffCurrent
      if (isSearch) {
        page = 1
        this.staffCurrent = 1
      }
      this.$http.get('/api/student', {
        params: {
          limit: 10,
          search: this.studentSearch,
          page: page,
        },
      }).then(({ data }) => {
        this.students = data.data
      })
    },
    searchStudents: function(value) {
      if (value) {
        this.studentSearch = value
        this.getStudents(true)
      }
    },

    handleChangeIssuedBy: function (value) {
      console.log(value)
      if (value) {
        this.selectedIssuedBy = value
      }
    },

    handleChangeTakenBy: function (value) {
      if (value) {
        this.selectedTakenBy = value
      }
    },
    handleChangeIssuedToStudent: function (value) {
      if (value) {
        this.selectedIssuedToStudent = value
      }
    },
    handleBundleProductQuantityChange: function (value) {
      const fieldData = {}
      this.bundledProductProducts.forEach((product, index) => {
        fieldData[`product_quantity[${product.product_id}]`] = product.quantity * value
      })
      this.form.setFieldsValue(fieldData)
    },
  },
}
</script>

<style>

</style>
